/* eslint-disable simple-import-sort/imports */
import React, { useRef, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { styled } from 'styled-components';

import { trackOpenAIVideoPlay } from 'utils/openaiPixel';

import { Reveal } from '../components/Motion';
import {
  Container,
  Eyebrow,
  Lead,
  Section,
  SectionHead,
  Title,
  v2,
} from '../v2';

const Wrapper = styled(Section)`
  background: ${v2.bgSoft};
  border-top: 1px solid ${v2.border};
  overflow: hidden;
`;

const Frame = styled(motion.div)`
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid ${v2.borderStrong};
  background: ${v2.bgElevated};
  box-shadow:
    0 50px 120px rgba(0, 0, 0, 0.55),
    0 0 90px rgba(30, 150, 252, 0.12);
  aspect-ratio: 16 / 9;

  iframe {
    width: 100%;
    height: 100%;
    display: block;
    border: 0;
  }
`;

const Poster = styled.button`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(160deg, rgba(30, 150, 252, 0.18), rgba(5, 9, 15, 0.6)),
    url('https://img.youtube.com/vi/RFfgnzXPQqQ/maxresdefault.jpg') center /
      cover no-repeat;
  cursor: pointer;
`;

const PlayButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 92px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(14px);
  transition:
    transform 0.3s ease,
    background 0.3s ease;

  svg {
    margin-left: 5px;
  }

  ${Poster}:hover & {
    transform: scale(1.12);
    background: rgba(30, 150, 252, 0.4);
  }
`;

const VideoV2 = () => {
  const [playing, setPlaying] = useState(false);
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const scale = useTransform(scrollYProgress, [0, 0.45], [0.92, 1]);
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <Wrapper ref={ref}>
      <Container>
        <SectionHead>
          <Reveal>
            <Eyebrow>FOXI in Aktion</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <Title>
              Sieh selbst, wie <span className="grad">einfach</span> es ist
            </Title>
          </Reveal>
          <Reveal delay={0.2}>
            <Lead>
              FOXI ist Deine neue Software, um Abrechnung und Dokumentation so
              einfach und schnell wie möglich zu machen!
            </Lead>
          </Reveal>
        </SectionHead>
        <Frame style={{ scale, y }}>
          {playing ? (
            <iframe
              src="https://www.youtube.com/embed/RFfgnzXPQqQ?autoplay=1"
              title="FOXI Video Overview"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <Poster
              aria-label="Video abspielen"
              onClick={() => {
                setPlaying(true);
                trackOpenAIVideoPlay();
              }}
            >
              <PlayButton>
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                  <path d="M7 4.5v15l13-7.5-13-7.5Z" fill="#fff" />
                </svg>
              </PlayButton>
            </Poster>
          )}
        </Frame>
      </Container>
    </Wrapper>
  );
};

export default VideoV2;
